import React from 'react';
import { Icon, WYSIWYGRenderer } from '@vectord/components';
import { useSelector } from 'react-redux';

import {
  FUTURE_CLASSES_VISIBILITY_DATA,
  learnerUpdateActionSelector,
  selectedSuperBatchSelector,
} from 'features/classCreation';
import styles from './FutureClassesVisibility.module.scss';

function FutureClassesVisibility() {
  const learnerUpdateAction = useSelector(learnerUpdateActionSelector);
  const selectedSuperBatch = useSelector(selectedSuperBatchSelector);
  const { batch_type: batchType } = selectedSuperBatch;

  return (
    <div className={styles.root}>
      <div className={styles.title}>To be scheduled Classes</div>
      <div className="p-xs">
        <Icon name="info" />
        <br />
        <WYSIWYGRenderer
          html={FUTURE_CLASSES_VISIBILITY_DATA[learnerUpdateAction][batchType]}
        />
      </div>
    </div>
  );
}

export default FutureClassesVisibility;
